import type React from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import "./index.css";
import { AppLayout } from "./layouts/AppLayout";
import { AccountPage, AdminPage } from "./pages/AccountPage";
import { LoginPage, OnboardingPage, RegisterPage } from "./pages/AuthPages";
import { CheckoutPage } from "./pages/CheckoutPage";
import { CreateListingPage } from "./pages/CreateListingPage";
import { HomePage } from "./pages/HomePage";
import { ListingDetailPage } from "./pages/ListingDetailPage";
import { MarketplacePage } from "./pages/MarketplacePage";
import { OrdersPage } from "./pages/OrdersPage";
import { OrderStatusPage } from "./pages/OrderStatusPage";
import { PacketsPage } from "./pages/PacketsPage";
import { PlaceholderPage } from "./pages/PlaceholderPage";
import { SellerInventoryPage } from "./pages/SellerInventoryPage";
import { routeConfig, routePath } from "./routes/routeConfig";

const appName = "Violet Exchange";
void appName;

type RouteId = (typeof routeConfig)[number]["id"];

const routeElements: Partial<Record<RouteId, React.ReactNode>> = {
  home: <HomePage />,
  marketplace: <MarketplacePage />,
  "listing-detail": <ListingDetailPage />,
  checkout: <CheckoutPage />,
  orders: <OrdersPage />,
  "order-status": <OrderStatusPage />,
  "seller-inventory": <SellerInventoryPage />,
  "create-listing": <CreateListingPage />,
  packets: <PacketsPage />,
  account: <AccountPage />,
  admin: <AdminPage />,
  login: <LoginPage />,
  register: <RegisterPage />,
  onboarding: <OnboardingPage />,
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      ...routeConfig.map(route => ({
        ...(route.path === "/" ? { index: true as const } : { path: routePath(route.path) }),
        element: routeElements[route.id] ?? <PlaceholderPage title={route.label} />,
      })),
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
